const featureFlagPrefix = 'REACT_APP_FEATURE_';
const localStorageFeaturePrefix = 'feature_';

const getFeatureFlagsFromEnv = (): Record<string, boolean> => {
  // Get all environment variables starting with REACT_APP_FEATURE_
  return Object.keys(process.env)
    .filter(key => key.startsWith(featureFlagPrefix))
    .reduce((flags: Record<string, boolean>, key) => {
      const flagName = key.replace(featureFlagPrefix, '').toLowerCase();
      flags[flagName] = process.env[key] === 'true';
      return flags;
    }, {});
};

// Load the default flags from the .env file
const defaultFeatureFlags = getFeatureFlagsFromEnv();

// Override with values from localStorage if available
const featureFlags = Object.keys(defaultFeatureFlags).reduce((flags: Record<string, boolean>, key) => {
  const storedValue = localStorage.getItem(localStorageFeaturePrefix + key);
  flags[key] = storedValue !== null ? JSON.parse(storedValue) : defaultFeatureFlags[key];
  return flags;
}, {});

const isFeatureEnabled = (feature: string): boolean => {
  return featureFlags[feature];
};

let toggleFeature = (feature: string): void => {
  if (!featureFlags.hasOwnProperty(feature)) {
    console.error('Feature flag', feature, 'does not exist');
    return;
  }
  featureFlags[feature] = !featureFlags[feature];
  localStorage.setItem(localStorageFeaturePrefix + feature, JSON.stringify(featureFlags[feature]));
  console.log('Feature flag', feature, 'is now', featureFlags[feature]);
  window.location.reload();
};

export { isFeatureEnabled, toggleFeature };
